module.exports = __webpack_public_path__ + "img/virtual_kit.3feec108.png";